exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".remove-pad-left {\n  padding-left: 0px !important; }\n\n.remove-pad-right {\n  padding-right: 0px !important; }\n\n.message-type-badge-color {\n  background-color: green !important;\n  margin-bottom: 4px !important; }\n\n.message-type-panel .panel-heading {\n  padding: 8px 14px !important; }\n\n.language-message-type-pagination {\n  padding: 5px 5px; }\n\n.language-message-list-group {\n  padding: 5px 5px !important; }\n  .language-message-list-group .list-group-item {\n    padding: 6px 15px !important; }\n\n.language-message-filter-section {\n  padding-left: 5px !important;\n  padding-right: 5px !important; }\n\n.msg-title-section {\n  margin-top: 16px;\n  margin-left: 5px; }\n\n.language-message-pagination-section .pagination {\n  display: inline-block;\n  margin-left: 5px !important; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/tnt_control/component/message/all/message.all.scss
// module id = 1153
// module chunks = 1